// src/utils/apiFetch.js
// Thin fetch wrapper — redirects to /billing on 402 (subscription expired).

export async function apiFetch(url, options = {}) {
  const response = await fetch(url, options);
  if (response.status === 402) {
    window.location.href = "/billing";
    return new Promise(() => {});
  }
  return response;
}
